export default __webpack_public_path__ + "static/media/img-o-n-video-where-to-start.acf3201f.jpg";